import { useCallback, useState } from 'react'

const useButtonSelector = (options) => {
  const [selected, setSelected] = useState({})
  const onSelectedChange = useCallback(
    (index) => {
      setSelected(options[index])
    },
    [options],
  )
  const resetSelected = useCallback(() => setSelected(null), [])
  return { selected, onSelectedChange, resetSelected }
}

export default useButtonSelector
